import { environment } from '@env/environment';

const version = new Date().getSeconds().toString() + new Date().getMilliseconds().toString();

export const microFrontendsMetadataHome = {
  elementUrl: environment.assetsUrl + `/mf-home/main.js?date=${version}`,
  selector: 'vdh-container',
  root: false,
  route: {
    path: 'inicio',
    default: true,
    children: [
      {
        path: 'utm',
        default: false,
      },
    ],
  },
};

export const microFrontendsMetadataSteps = {
  elementUrl: environment.assetsUrl + `/mf-steps/main.js?date=${version}`,
  selector: 'vdst-container',
  root: false,
  seeker: true,
  route: {
    default: false,
    path: 'abrir-cuenta',
    children: [
      {
        path: 'ahorros-4/inicio-apertura',
        default: true,
      },
      {
        path: '360/inicio-apertura',
        default: false,
      },
      {
        path: 'ahorro-efectivo/inicio-apertura',
        default: false,
      },
      {
        path: 'sueldo/inicio-apertura',
        default: false,
      },
      {
        path: ':savingsAccount/dolares/inicio-apertura',
        default: false,
      },
      {
        path: ':savingsAccount/inicio-apertura-otp',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/reconocimiento-facial',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/redireccion',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/redireccion-success',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/confirmacion',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/verificacion',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/contrato',
        default: false,
      },
      {
        path: ':savingsAccount/:clientType/cuenta-creada',
        default: false,
      },
    ],
  },
};

export const microFrontendsMetadataLoan = {
  elementUrl: environment.assetsUrl + `/mf-loan/main.js?date=${version}`,
  selector: 'vdl-container',
  root: false,
  seeker: true,
  route: {
    default: false,
    path: 'prestamo-personal',
    children: [
      {
        path: 'gral/datos',
        default: true,
      },
      {
        path: 'gral/redireccion',
        default: false,
      },
      {
        path: ':clientType/preguntas',
        default: false,
      },
      {
        path: ':clientType/cuenta',
        default: false,
      },
      {
        path: ':clientType/configurar-prestamo',
        default: false,
      },
      {
        path: ':clientType/configurar-prestamo-colaborador',
        default: false,
      },
      {
        path: ':clientType/configurar-microprestamo',
        default: false,
      },
      {
        path: ':clientType/aceptar-prestamo',
        default: false,
      },
      {
        path: ':clientType/guardar-loan',
        default: false,
      },
      {
        path: ':clientType/reconocimiento-facial',
        default: false,
      },
      {
        path: ':clientType/verificacion',
        default: false,
      },
      {
        path: ':clientType/empty-page',
        default: false,
      },
      {
        path: ':clientType/aprobado',
        default: false,
      },
      {
        path: ':clientType/biometria',
        default: false,
      },
      {
        path: ':clientType/seguro-proteccion-pagos',
        default: false,
      },
    ],
  },
};

export const microFrontendsMetadataFTD = {
  elementUrl: environment.assetsUrl + `/mf-ftd/main.js?date=${version}`,
  selector: 'vdftd-container',
  root: false,
  seeker: true,
  route: {
    default: false,
    path: 'plazo-fijo',
    children: [
      {
        path: 'abrir-deposito/datos-personales',
        default: true,
      },
      {
        path: 'abrir-deposito/login',
        default: false,
      },
      {
        path: 'abrir-deposito/balance-status',
        default: false,
      },
      {
        path: 'abrir-deposito/seleccion-deposito',
        default: false,
      },
      {
        path: 'abrir-deposito/configurar-monto',
        default: false,
      },
      {
        path: 'abrir-deposito/seleccion-cuenta',
        default: false,
      },
      {
        path: 'abrir-deposito/reconocimiento-facial',
        default: false,
      },
      {
        path: 'abrir-deposito/verificacion-datos',
        default: false,
      },
      {
        path: 'abrir-deposito/proceso-exitoso',
        default: false,
      },
      {
        path: 'abrir-deposito/redireccion',
        default: false,
      },
    ],
  },
};

//enrolamiento
export const microFrontendsMetadataEnrollment = {
  elementUrl: environment.assetsUrl + `/mf-enrollment/main.js?date=${version}`,
  selector: 'vden-container',
  root: false,
  seeker: true,
  route: {
    default: false,
    path: 'registro-usuario',
    children: [
      {
        path: 'apertura',
        default: true,
      },
      {
        path: 'formulario',
        default: false,
      },
      {
        path: 'terminos',
        default: false,
      },
    ],
  },
};

///Biometria
export const microFrontendsMetadataBiometrics = {
  elementUrl: environment.assetsUrl + `/mf-biometrics/main.js?date=${version}`,
  selector: 'vdbi-container',
  root: false,
  seeker: true,
  route: {
    default: false,
    path: 'reconocimiento-facial',
    children: [
      {
        path: 'empezar-validacion',
        default: true,
      },
      {
        path: 'paso-iluminacion',
        default: false,
      },
      {
        path: 'paso-accesorios',
        default: false,
      },
      {
        path: 'biometria',
        default: false,
      },
      {
        path: 'documentos-empezar',
        default: false,
      },
      {
        path: 'documentos-iluminacion',
        default: false,
      },
      {
        path: 'documentos-validacion',
        default: false,
      },
    ],
  },
};
